<!--<template>我是图</template>-->
<template>
    <div ref="chartContainer"
         :style="'text-align: center; width: ' + (width || '100%') + '; height: '+ (height || '450px')+ ' ;'">
    </div>
</template>

<script setup>
    import {  defineProps, ref, onMounted } from 'vue';
    import * as echarts from 'echarts';
    const props = defineProps({
        id: String,
        title: String,
        option: Object,
        width: String,
        height: String,
        postfix: String,
    });
    const chartContainer = ref(null);
    const chartOption = ref(props.option);
    let chart = ref(null);
    onMounted( () => {
        chart.value = echarts.init(chartContainer.value, null, {renderer: props.postfix || 'png'});
        updateChart();
    });
    const updateChart = ()=>{
        if(chart.value){
            // chart.value.clear();
            chart.value.setOption(chartOption.value);
        }
    };

</script>